module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_8011.ff8e3ca9.png";